module.exports = __webpack_public_path__ + "img/White-Marble-PBR-texture-3D-free-download-High-resolution-Unity-Unreal-Vray-render-full.4061eafe.jpg";